import { Pipe, PipeTransform } from '@angular/core';
import { Distinct, DistinctByKey, OrderByKey, OrderBySelector } from '../definitions/array.definitions';

@Pipe({name: 'orderBy'})
export class OrderByPipe implements PipeTransform {
    readonly transform = OrderBySelector;
}

@Pipe({name: 'orderByKey'})
export class OrderByKeyPipe implements PipeTransform {
    readonly transform = OrderByKey;
}

@Pipe({name: 'distinct'})
export class DistinctPipe implements PipeTransform {
    readonly transform = Distinct;
}

@Pipe({name: 'distinctByKey'})
export class DistinctByKeyPipe implements PipeTransform {
    readonly transform = DistinctByKey;
}
